import { dsVar } from '../../theme/tokens';

/**
 * The look for a Select used as chrome rather than as a form field, in either theme.
 *
 * Lifted out of CaseWorkflowFilters so the workspace selector in the top bar
 * matches the filter bar below it instead of carrying a third copy.
 */
export const control = {
    fontSize: '0.8125rem',
    color: dsVar('fg-soft'),
    backgroundColor: dsVar('page'),
    minWidth: 150,
    '.MuiOutlinedInput-notchedOutline': { borderColor: dsVar('line') },
    '.MuiSvgIcon-root': { color: dsVar('fg-muted') }
};

export const menu = {
    PaperProps: { sx: { backgroundColor: dsVar('surface'), color: dsVar('fg-body') } }
};
